<template>
  <div
    class="Fuell-Overlay"
    @click.self="closeModal"
    v-if="visible"
  >
    <div class="Fuell-Modal">
      <div class="Fuell-Modal--window large Fuell-Modal--window--centered">
        <div class="Fuell-Modal--header">
          <button
            class="Fuell-Modal--close-button"
            @click="closeModal"
          >
            <img
              :src="require('@/assets/img/icons/icon-remove-user.svg')"
              alt="close"
            />
          </button>
          <h3 class="Fuell-Modal--title">
            <span v-t="{ path: 'users_invite_user' }"></span>
          </h3>

          <button
            type="submit"
            form="user-form"
            id="massive-upload-button"
            class="Fuell-Button blue small"
            :disabled="!canBeSubmitted || isCallingUsers"
          >
            <span
              class="Fuell-Button--label"
              v-t="{ path: 'customer_creation_invite_customer' }"
            ></span>
          </button>
        </div>
        <form
          class="w-100"
          @submit.prevent="sendInvites"
          id="user-form"
        >
          <div
            class="users-invite-modal--container"
            v-for="(user, index) in users"
            :key="index"
          >
            <div class="row users-invite-modal--row">
              <div class="col-12">
                <p class="users-invite-modal--user">{{ `${$t('USER')} ${index + 1}` }}</p>
              </div>
              <div class="col-12 col-sm-6 col-md input--block users-invite-modal--col-first">
                <label class="form--label u-required">{{
                  $t('NAME').toUpperCase()
                }}</label>
                <div
                  class="Form-field required"
                  :class="{
                  'Form--field-error': $v.users.$each[index].firstName.$error
                }"
                  v-focus-input
                >
                  <input
                    type="text"
                    name="name"
                    class="Input-text"
                    :placeholder="$t('NAME')"
                    @blur="$v.users.$each[index].firstName.$touch()"
                    v-model="user.firstName"
                  />
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md input--block users-invite-modal--col-normal">
                <label class="form--label">
                  {{ $t('LAST_NAME').toUpperCase() }}</label>
                <div class="Form-field">
                  <input
                    type="text"
                    name="last-name"
                    class="Input-text"
                    :placeholder="$t('LAST_NAME')"
                    v-model="user.lastName"
                  />
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md input--block users-invite-modal--col-normal">
                <label class="form--label u-required">{{
                  $t('EMAIL').toUpperCase()
                }}</label>
                <div
                  class="Form-field required"
                  :class="{ 'Form--field-error': $v.users.$each[index].email.$error }"
                  v-focus-input
                >
                  <input
                    type="text"
                    name="email"
                    :placeholder="$t('EMAIL')"
                    class="Input-text"
                    @blur="$v.users.$each[index].email.$touch()"
                    v-model="user.email"
                  />
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-2 col-md input--block users-invite-modal--col-last">
                <label class="form--label u-required">{{
                  $t('ROLES').toUpperCase()
                }}</label>
                <multiselect
                  class="multiselect--roles"
                  :placeholder="$t('ROLES')"
                  open-direction="bottom"
                  :value="users[index].role"
                  :customLabel="(option) => $t(option)"
                  :options="roles"
                  :multiple="false"
                  :searchable="false"
                  :selectLabel="''"
                  :selectedLabel="''"
                  :deselectLabel="''"
                  @select="setUserRole(index, $event)"
                >
                </multiselect>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-6 col-md-4 input--block users-invite-modal--col-first">
                <label class="form--label"
                :class="{'u-required' : isUser}"
                >{{
                  $t('BUDGETS').toUpperCase()
                }}</label>
                <multi-select-custom
                  v-model="user.budgets"
                  :closeOnSelect="false"
                  :options="budgets"
                  :label="['name']"
                  :placeholder="$t('BUDGETS')"
                  :classList="'multiselect--budgets'"
                  :disabled="user.role === 'ROLE_BOOKKEEPER'"
                  @setSelectedItems="setUserBudgets(index, $event)"
                  @removeItem="removeUserBudget(index, $event)"
                ></multi-select-custom>
              </div>
              <div class="col-12 col-sm-6 col-md-4 input--block users-invite-modal--col-normal">
                <label class="form--label">{{
                  $t('IDENTIFIER').toUpperCase()
                }}</label>
                <div
                  class="Form-field"
                  v-focus-input
                >
                  <input
                    type="text"
                    name="identifier"
                    :placeholder="$t('IDENTIFIER_PLACEHOLDER')"
                    class="Input-text"
                    v-model="user.identifier"
                  />
                </div>
              </div>
              <div
                class="col-12 col-sm-6 col-md-4 input--block"
                :class="expenseCenterClass"
              >
                <label class="form--label">{{
                  $t('EXPENSE_CENTER').toUpperCase()
                }}</label>
                <div
                  class="Form-field"
                  v-focus-input
                >
                  <input
                    type="text"
                    name="expenseCenter"
                    :placeholder="$t('EXPENSE_CENTER_PLACEHOLDER')"
                    class="Input-text"
                    v-model="user.expenseCenter"
                  />
                </div>
              </div>
              <div
                v-if="canEmmitCards && user.role && user.role !== 'ROLE_BOOKKEEPER'"
                class="col-12 col-sm-6 col-md-4 users-invite-modal--col-last users-invite-modal--col-card flex-column"
              >
                <label
                  for=""
                  class="form--label d-flex justify-content-start align-items-center"
                > {{$t('users_expense_type_label').toUpperCase()}} <info-display :iconClass="'users-invite-modal--col-card--info-tooltip'" :infoText="userExpenseTypeLabel" /></label>
                <div class="d-flex">
                  <input-radio
                    :label="'customer_user_without_cards'"
                    v-if="hasOptionalCards"
                    :itemValue="user.typeOfCardWhenRegisteredOnIssuer"
                    :value="cardEmissionTypes.WITHOUT_CARDS"
                    @click="setUserCardType(index, $event)"
                  ></input-radio>
                  <input-radio
                    :label="'transactions_card_type__MEMBER_VIRTUAL'"
                    :itemValue="user.typeOfCardWhenRegisteredOnIssuer"
                    :value="cardEmissionTypes.VIRTUAL"
                    @click="setUserCardType(index, $event)"
                  ></input-radio>
                  <input-radio
                    :label="'transactions_card_type__MEMBER_PHYSICAL'"
                    :itemValue="user.typeOfCardWhenRegisteredOnIssuer"
                    :value="cardEmissionTypes.PHYSICAL"
                    @click="setUserCardType(index, $event)"
                  ></input-radio>
                </div>
              </div>
            </div>
            <div
              class="users-invite-modal--close"
              v-if="index >= 1"
              @click="removeItem(index)"
            >
              <img
                :src="require('@/assets/img/icons/icon-remove-user.svg')"
                alt="close"
              />
            </div>
          </div>
          <div class="row">
            <p
              class="col-12 text-right"
              @click="addUser"
            >
              <span class="add-user">
                {{ $t('users_add_user') }}
              </span>
            </p>
          </div>
          <div
            class="row d-flex justify-content-center"
            v-if="isCallingUsers"
          >
            <spinner></spinner>
          </div>
        </form>
        <div class="Fuell-Modal--footer">
          <div class="role-info Fuell-Text flex">
            {{ $t('user_role_help_text') }}
            <a
              class="link ml-2"
              href="http://support.getfuell.com/es/articles/3933974-diferencias-entre-un-usuario-admin-regular-y-contable"
              target="_blank"
              rel="noopener"
            >{{ $t('user_role_read_more') }}</a>

            <button v-if="!isUser"
              :disabled="isCallingUsers"
              class="Fuell-Button small ml-auto"
              type="button"
              @click="showMassiveUploadForm()"
            >
              <span class="Fuell-Button--label">{{ $t('users_invite_massive_upload') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
import Spinner from '@/components/Commons/Spinner'
import InputRadio from '@/components/Commons/Forms/InputRadio'
import MultiSelectCustom from '@/components/Commons/Forms/MultiSelectCustom'
import InfoDisplay from '@/components/Commons/InfoDisplay'
import { USER_ROLES } from '../../_constants/userTypes'
import { USER_CARDS_TYPE } from '@/constants/userCardsType'
import { CARD_EMISSION_TYPE } from '@/modules/customers/_constants/constants'

const { validationMixin } = require('vuelidate')
const { required, requiredIf, email, minLength } = require('vuelidate/lib/validators')

export default {
  name: 'OfficeUsersUserInvite',
  mixins: [validationMixin, _modalHandlerMixin],
  components: { Spinner, Multiselect, MultiSelectCustom, InputRadio, InfoDisplay },
  data () {
    return {
      budgetsSelected: undefined,
      users: [
        {
          firstName: '',
          lastName: '',
          email: '',
          role: '',
          userCardsType: false,
          typeOfCardWhenRegisteredOnIssuer: CARD_EMISSION_TYPE.WITHOUT_CARDS,
          budgets: [],
          identifier: '',
          expenseCenter: ''
        }
      ]
    }
  },
  validations: {
    users: {
      required,
      minLength: minLength(1),
      $each: {
        firstName: {
          required,
          latinAlpha: (value) => /^[^0-9!<>,;?=+()@#"°{}_€$%:]*$/.test(value)
        },
        lastName: { latinAlpha: (value) => /^[^0-9!<>,;?=+()@#"°{}_€$%:]*$/.test(value) },
        email: { required, email },
        role: { required },
        budgets: {
          required: requiredIf(function () {
            return this.isUser
          })
        }
      }
    }
  },
  methods: {
    async sendInvites () {
      let invitedUsers = [...this.users]
      if (this.hasOptionalCards) {
        const users = invitedUsers.map(el => {
          let user = { ...el }
          if (el.typeOfCardWhenRegisteredOnIssuer !== CARD_EMISSION_TYPE.WITHOUT_CARDS) {
            user.userCardsType = USER_CARDS_TYPE.USER_CARDS_ALWAYS
          } else {
            user.userCardsType = USER_CARDS_TYPE.USER_CARDS_WITHOUT
            delete user.typeOfCardWhenRegisteredOnIssuer
          }
          user.budgets = el.budgets.map(item => ({ id: item.id }))
          return user
        })
        invitedUsers = [...users]
      } else {
        invitedUsers.forEach(el => {
          el.budgets = el.budgets.map(item => ({ id: item.id }))
          delete el.userCardsType
        })
      }

      await this.$store.dispatch('UsersStore/inviteUsers', {
        officeId: this.userOfficeId,
        users: invitedUsers
      })
      this.users = [{
        firstName: '',
        lastName: '',
        email: '',
        role: '',
        budgets: [],
        identifier: '',
        expenseCenter: '',
        typeOfCardWhenRegisteredOnIssuer: this.hasOptionalCards ? CARD_EMISSION_TYPE.WITHOUT_CARDS : CARD_EMISSION_TYPE.VIRTUAL
      }]

      this.$v.$reset()
      this.closeModal()
    },
    addUser () {
      this.users.push({
        firstName: '', lastName: '', email: '', role: '', budgets: [], identifier: '', expenseCenter: '', typeOfCardWhenRegisteredOnIssuer: this.hasOptionalCards ? CARD_EMISSION_TYPE.WITHOUT_CARDS : CARD_EMISSION_TYPE.VIRTUAL
      })
    },
    setUserRole (index, event) {
      if (event && event.target) {
        this.users[index].role = event.target.value
      } else {
        this.users[index].role = event
      }
      this.$v.users.$each[index].role.$touch()
      if (this.users[index].role === USER_ROLES.ROLE_BOOKKEEPER) {
        this.users[index].budgets = []
      }
    },
    setUserBudgets (index, event) {
      if (this.users[index].budgets.indexOf(event.id) === -1) {
        this.users[index].budgets.push(event)
      }
    },
    removeUserBudget (index, event) {
      this.users[index].budgets.splice(this.users[index].budgets.map(item => item.id).indexOf(event.id), 1)
    },
    removeItem (index) {
      this.users.splice(index, 1)
    },
    showMassiveUploadForm () {
      this.$emit('showMassiveUploadForm')
    },
    setUserCardType (index, event) {
      this.users[index].typeOfCardWhenRegisteredOnIssuer = event
    },

    async fetchBudgets () {
      const filters = {
        'status.code': 'ACTIVE',
        pagination: false
      }
      await this.$store.dispatch('BudgetsStore/setBudgetsFilters', filters)
    }
  },
  computed: {
    user () {
      return this.$store.getters['LoginStore/user']
    },
    isUser () {
      return this.$store.getters['LoginStore/isUser']
    },
    isNotBookkeeper () {
      return this.hasOptionalCards && !this.user.roles.includes('ROLE_BOOKKEEPER')
    },
    expenseCenterClass () {
      return this.isNotBookkeeper ? 'users-invite-modal--col-normal' : 'users-invite-modal--col-last'
    },
    budgets () {
      return this.$store.getters['BudgetsStore/budgets'].filter(el => el.type.code === 'NORMAL') || []
    },
    privateConfig () {
      return this.$store.getters['ConfigStore/privateConfig']
    },
    cardEmissionTypes () {
      return CARD_EMISSION_TYPE
    },

    roles () {
      if (this.privateConfig && this.privateConfig.roles) {
        return this.privateConfig.roles.filter((el) => el !== USER_ROLES.ROLE_ADMIN)
      } else {
        return [USER_ROLES.ROLE_REGULAR, USER_ROLES.ROLE_BOOKKEEPER]
      }
    },
    canBeSubmitted () {
      return !this.$v.$invalid
    },
    userOfficeId () {
      if (
        this.$store.getters['CompanyStore/currentCompany'] &&
        this.$store.getters['CompanyStore/currentCompany'].id
      ) {
        return this.$store.getters['CompanyStore/currentCompany'].id
      } else {
        return this.$store.getters['LoginStore/user'].office_id
      }
    },
    isCallingUsers () {
      return this.$store.getters['UsersStore/isCallingUsers']
    },
    currentCompany () {
      return this.$store.getters['CompanyStore/currentCompany']
    },
    currentCompanyCardUsageType () {
      return this.currentCompany ? this.currentCompany.officeCardsType : false
    },
    hasOptionalCards () {
      return this.currentCompanyCardUsageType && this.currentCompanyCardUsageType === 'OFFICE_CARDS_OPTIONAL'
    },
    hasCards () {
      return this.currentCompanyCardUsageType && this.currentCompanyCardUsageType === 'OFFICE_CARDS_ALWAYS'
    },
    canEmmitCards () {
      return this.hasCards || this.hasOptionalCards
    },
    userExpenseTypeLabel () {
      return this.hasOptionalCards ? this.$i18n.t('users_expense_type_label_optional_cards') : this.$i18n.t('users_expense_type_label_cards')
    }
  },
  async created () {
    if (this.hasCards) {
      this.users[0].typeOfCardWhenRegisteredOnIssuer = CARD_EMISSION_TYPE.VIRTUAL
    }
    await this.fetchBudgets()
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped lang="scss">
.role-info {
  margin: 12px 0 6px;
}

.link {
  cursor: pointer;
  font-size: 15px;
  color: var(--text-link);
}

.Fuell-Modal--window {
  padding: 0 22px 0;
  max-width: 80vw !important;
  width: 100%;
  overflow: auto;
  max-height: 622px;
}

.Fuell-Modal--header {
  position: sticky;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0 12px;
  height: 56px;
  background-color: var(--white);
  z-index: 2;
  margin-bottom: 8px;

  .Fuell-Modal--close-button {
    position: unset;
    display: block;
    width: 8px;
    height: 8px;
    padding: 0;

    img {
      display: block;
      width: 8px;
      height: 8px;
    }
  }

  .Fuell-Modal--title {
    margin: 0;
  }
}

.add-user {
  cursor: pointer;
  font-weight: 500;
  font-size: 13px;
  line-height: 24px;
  text-align: right;
  color: var(--text-link);
}

.Fuell-Modal--footer {
  position: sticky;
  bottom: 0;
  background-color: var(--white);
  height: 64px;
  padding-bottom: 16px;
  z-index: 2;
}

.users-invite-modal {
  &--container {
    position: relative;
    margin-bottom: 8px;
    padding: 16px;
    border: 1px solid var(--fill-border);
    border-radius: 6px;
  }

  &--close {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 8px;
    height: 8px;
    cursor: pointer;

    img {
      display: block;
      width: 8px;
      height: 8px;
    }
  }

  &--row {
    margin-bottom: 8px;
  }

  &--user {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: var(--text-heading);
    margin-bottom: 8px;
  }

  &--col-first {
    padding-right: 0;
  }

  &--col-normal {
    padding-right: 0;
    padding-left: 8px;
  }

  &--col-last {
    padding-left: 16px;
  }

  &--col-card {
    display: flex;
    margin-top: 16px;
    &--info-tooltip {
      margin-left:5px;
      width:13px;
      height:13px;
    }
  }
}

@media (max-width: 768px) {
  .input--block {
    margin: 10px 0px;
  }
}

@media screen and (max-width: 768px) {
  .role-info {
    max-height: 100px;
    height: 100%;
    margin-top: 10px;
  }

  .users-invite-modal {
    &--row {
      margin-bottom: 0;
    }

    &--col-first {
      padding: 0 15px;
      margin-bottom: 8px;
    }

    &--col-normal {
      padding: 0 15px;
      margin-bottom: 8px;
    }

    &--col-last {
      padding: 0 15px;
      margin-bottom: 8px;
    }

    &--col-card {
      display: flex;
      align-items: center;
      margin-top: 16px;
    }
  }
}
</style>
<style lang="scss">
.multiselect--budgets {
  .multiselect__select {
    padding: 8px;
    height: 100%;

    &:before {
      content: "⌵";
      border: none;
      top: 0;
      margin: 0;
    }
  }

  .multiselect__tags {
    padding-top: 8px;
    padding-bottom: 8px;

    .multiselect__placeholder {
      margin: 0;
      padding: 0;
      line-height: 21px;
    }
  }

  .multiselect__single {
    height: 26px;
    line-height: 26px;
  }
}
</style>
